export default __webpack_public_path__ + "static/media/activity-improve.efb9d18a.svg";